import { Filter, CustomFilter } from 'common/constants'
import { ListFilter } from 'common/types/entities/list'
import { StateKey } from 'common/utils/flipState'

const initialState: ListFilter = {
  npay: null,
  filter: null,
  customFilter: CustomFilter.NONE,
  isOpened: false,
}

const INIT = '/list/filter/INIT'
const SET = '/list/filter/SET'
const SET_CUSTOM = '/list/filter/SET_CUSTOM'
const SET_NPAY = '/list/filter/Npay/SET'
const OPEN_CLOSE_SORT = '/list/filter/OPEN_CLOSE_SORT'

export const initNpay = (curState: StateKey, queryParams: any) => {
  const npay = queryParams && queryParams['npay'] && queryParams['npay'] === 'true'

  return {
    curState,
    npay,
    type: SET_NPAY,
    isOpened: false,
  }
}

export const initFilter = (curState: StateKey, filter: Filter) => {
  const initialFilter = filter && filter in Filter ? filter : Filter.ALL

  return {
    curState,
    filter: initialFilter,
    type: INIT,
    isOpened: false,
  }
}

export const setNpay = (curState: StateKey, npay: boolean) => {
  return {
    curState,
    npay,
    type: SET_NPAY,
    isOpened: false,
  }
}

export const setFilter = (curState: StateKey, filter: Filter) => {
  return {
    curState,
    filter,
    type: SET,
    isOpened: false,
  }
}

export const setCustomFilter = (curState: StateKey, customFilter: CustomFilter) => {
  return {
    curState,
    customFilter,
    type: SET_CUSTOM,
    isOpened: false,
  }
}

export const openAndCloseFilter = (curState: StateKey, isOpened: boolean) => {
  return {
    curState,
    isOpened,
    type: OPEN_CLOSE_SORT,
  }
}

const filterReducer = (state: ListFilter = initialState, action) => {
  switch (action.type) {
    case INIT:
      return { ...initialState, filter: action.filter, isOpened: action.isOpened }
    case SET:
      return { ...state, filter: action.filter, isOpened: action.isOpened }
    case SET_NPAY:
      return { ...state, npay: action.npay, isOpened: action.isOpened }
    case SET_CUSTOM:
      return { ...state, customFilter: action.customFilter, isOpened: action.isOpened }
    case OPEN_CLOSE_SORT:
      return { ...state, isOpened: action.isOpened }
    default:
      return state
  }
}

export default filterReducer
